// ./components/nzuac-helpers/SmootherContext.js
import { createContext } from 'react';

export const SmootherContext = createContext({
  smoother: null,
  settingsData: null,
});
